<template>
    <div class="conference_main_box">
        <MeetingGuard :room-id="roomId" :meetingType="'private'" />
    </div>
</template>

<script>
/* eslint-disable */
import MeetingGuard from "./meetingGuard.vue";

export default {
    components:{
        MeetingGuard
    },

    data(){
        return{
            roomId:""
        }
    },

    mounted(){
        document.body.classList.add(
            "video_conference_page"
        );

        if(!window.location.hash){
            window.location.hash =
                Date.now().toString(36) +
                Math.random().toString(36).substring(2);
        }

        this.roomId = window.location.hash.substring(1);
    },

    beforeDestroy(){
        document.body.classList.remove(
            "video_conference_page"
        );
    }
}
</script>